import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../../shared/components/dashboard-layout/components/modal/modalComponent";
import "./delete-user-confirmation-modal.scss";

const DeleteUserConfirmationModal = ({ show, onClose, onDelete, userName }) => {
  if (!show) return null;

  return (
    <Modal
      isVisible={show}
      onClose={onClose}
      header={`Confirm deletion of user${userName ? `: ${userName}` : ""}`}
      className="delete-user-confirmation-modal"
      cancelButtonLabel="Cancel"
      cancelButtonAction={onClose}
      negativeButtonLabel="Yes, delete this user"
      negativeButtonAction={onDelete}
    >
      <div className="deleteUserConfirmationBody">
        <div className="confirmation-content">
          <p className="confirmation-message">
              Are you sure you want to delete the user <strong>{userName}</strong>?
          </p>
          <p className="warning-text">This action cannot be undone.</p>
        </div>
      </div>
    </Modal>
  );
};

DeleteUserConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

export default DeleteUserConfirmationModal;
